import { st } from "~/sassmall/i18n";
import { getSassmallResponseMessage, isSassmallResponseSuccess, sassmallRequest } from './client'

export async function listSassmallWarehouseOptions() {
  const response = await sassmallRequest<Array<Record<string, any>>>('/warehouse/options', { method: 'GET' })
  if (!isSassmallResponseSuccess(response)) {
    throw new Error(getSassmallResponseMessage(response, st("仓库加载失败")))
  }
  return Array.isArray(response.data) ? response.data : []
}

export async function listSassmallLogisticsRouteDestinations(warehouseCode: string) {
  const normalizedWarehouseCode = String(warehouseCode || '').trim()
  if (!normalizedWarehouseCode)
    return []
  const query = new URLSearchParams({ warehouseCode: normalizedWarehouseCode })
  const response = await sassmallRequest<string[]>(`/warehouse/logistics-routes/destinations?${query.toString()}`, {
    method: 'GET',
  })
  if (!isSassmallResponseSuccess(response)) {
    throw new Error(getSassmallResponseMessage(response, st("目的地加载失败")))
  }
  return Array.isArray(response.data) ? response.data : []
}

export async function estimateSassmallLogisticsRoutes(payload: Record<string, any>) {
  const response = await sassmallRequest<Array<Record<string, any>>>('/warehouse/logistics-routes/estimate', {
    method: 'POST',
    body: payload,
  })
  if (!isSassmallResponseSuccess(response)) {
    throw new Error(getSassmallResponseMessage(response, st("运费预估失败")))
  }
  return Array.isArray(response.data) ? response.data : []
}

export function getSassmallWarehouseSummary() {
  return sassmallRequest<Record<string, any>>('/warehouse/summary', { method: 'GET' })
}

export function pageSassmallWarehousePackages(payload: Record<string, any>) {
  return sassmallRequest<Record<string, any>>('/warehouse/packages/page', { method: 'POST', body: payload })
}

export function getSassmallWarehousePackageDetail(id: string | number) {
  return sassmallRequest<Record<string, any>>(`/warehouse/packages/${encodeURIComponent(String(id))}`, { method: 'GET' })
}

export function resolveSassmallPackingGroup(payload: Record<string, any>) {
  return sassmallRequest<Record<string, any>>('/warehouse/packing-groups/resolve', { method: 'POST', body: payload })
}

export function validateSassmallPackingGroup(payload: Record<string, any>) {
  return sassmallRequest<Record<string, any>>('/warehouse/packing-groups/validate', { method: 'POST', body: payload })
}

export function resolveSassmallMemberPackages(payload: Record<string, any>) {
  return sassmallRequest<Record<string, any>>('/warehouse/member-packages/resolve', { method: 'POST', body: payload })
}
